module.exports = __webpack_public_path__ + "static/media/levelSquamish.6a4474c9.jpg";